import { atom } from "recoil";

// membership page product select state
const productSelect = atom({
  key: "productSelect",
  default: "basic",
});

export { productSelect };
